import { defineMessage } from 'react-intl';

/**
 *  Only a few of the descriptions have been filled in.
 *  This is because the translations migrated over from another translation system, and we essentially used the desc
 *  as a key to map the translations
 */
export const milestoneMessages = {
    labels: {
        assists: defineMessage({
            defaultMessage: 'Assists',
            description: 'milestone.assists_label',
        }),
        currentTeam: defineMessage({
            defaultMessage: 'Current Team',
            description: 'milestone.current_team_label',
        }),
        denotesReachedMilestone: defineMessage({
            defaultMessage: 'denotes reached milestone',
            description: 'milestone.denotes_reached_milestone_label',
        }),
        games_played: defineMessage({
            defaultMessage: 'Games Played',
            description: 'milestone.games_played_label',
        }),
        goalies: defineMessage({
            defaultMessage: 'Goalies',
            description: 'milestone.goalies_label',
        }),
        goals: defineMessage({
            defaultMessage: 'Goals',
            description: 'milestone.goals_label',
        }),
        milestone: defineMessage({
            defaultMessage: 'Milestone',
            description: 'milestone.milestone_label',
        }),
        minutes: defineMessage({
            defaultMessage: 'Minutes',
            description: 'milestone.goalie_min_header_label',
        }),
        playerFullName: defineMessage({
            defaultMessage: 'Player Name',
            description: 'milestone.playerFullName',
        }),
        points: defineMessage({
            defaultMessage: 'Points',
            description: 'milestone.points_label',
        }),
        skaters: defineMessage({
            defaultMessage: 'Skater',
            description: 'milestone.skater_label',
        }),
        shutouts: defineMessage({
            defaultMessage: 'Shutouts',
            description: 'milestone.goalie_so_header_label',
        }),
        wins: defineMessage({
            defaultMessage: 'Wins',
            description: 'milestone.wins_label',
        }),
    },
    linkLabels: {
        assists: defineMessage({
            defaultMessage: 'Active Assist Leaders >',
            description: 'milestone.skater_a_leaders_link_label',
        }),
        games_played: defineMessage({
            defaultMessage: 'Active Games Played Leaders >',
            description: 'milestone.gp_leaders_link_label',
        }),
        goals: defineMessage({
            defaultMessage: 'Active Goal Leaders >',
            description: 'milestone.skater_g_leaders_link_label',
        }),
        minutes: defineMessage({
            defaultMessage: 'Active Minute Leaders >',
            description: 'milestone.goalie_min_leaders_link_label',
        }),
        points: defineMessage({
            defaultMessage: 'Active Point Leaders >',
            description: 'milestone.skater_p_leaders_link_label',
        }),
        shutouts: defineMessage({
            defaultMessage: 'Active Shutout Leaders >',
            description: 'milestone.goalie_so_leaders_link_label',
        }),
        wins: defineMessage({
            defaultMessage: 'Active Win Leaders >',
            description: 'milestone.goalie_w_leaders_link_label',
        }),
    },
    columnAbbrevs: {
        assists: defineMessage({
            defaultMessage: 'A',
            description: 'milestone.assists_abbrev_label',
        }),
        games_played: defineMessage({
            defaultMessage: 'GP',
            description: 'milestone.games_played_abbrev_label',
        }),
        goals: defineMessage({
            defaultMessage: 'G',
            description: 'milestone.goals_abbrev_label',
        }),
        minutes: defineMessage({
            defaultMessage: 'Min',
            description: 'milestone.minutes_abbrev_label',
        }),
        points: defineMessage({
            defaultMessage: 'P',
            description: 'milestone.points_abbrev_label',
        }),
        shutouts: defineMessage({
            defaultMessage: 'SO',
            description: 'milestone.shutouts_abbrev_label',
        }),
        wins: defineMessage({
            defaultMessage: 'W',
            description: 'milestone.wins_abbrev_label',
        }),
    },
};
